import type { RoleNormalized } from "../types/index";

/**
 * Lowercase + trim a value to a normalized string.
 * Local copy — shared.ts has the canonical export, but importing it here
 * would create a circular dependency (formatting → shared → state → formatting).
 */
function normalizeValue(value: any): string {
  return String(value || "").trim().toLowerCase();
}

/**
 * Format a number with locale separators (en-US).
 * Returns "0" for NaN / falsy input.
 */
export function formatNumber(n: any): string {
  return new Intl.NumberFormat("en-US").format(Number(n || 0));
}

/**
 * Format a date string to YYYY-MM-DD.
 * Returns "" for falsy input.
 */
export function formatDate(dateStr: any): string {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Normalize a role string to one of the three canonical roles.
 * - viewer -> ecf
 * - forecaster -> market
 * - unknown -> market (default)
 */
export function normalizeRole(role: any): RoleNormalized {
  const value = normalizeValue(role);
  if (value === "viewer") return "ecf";
  if (value === "forecaster") return "market";
  if (value === "ecf" || value === "market" || value === "admin") return value;
  return "market";
}
